import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  maxHeight: ${(props) => (props.maxHeight)};
  height: ${(props) => (props.height)};
`;

export const ContentImage = styled.div`
  position: relative;
`;
